(() => {
  if (customElements.get('load-more')) {
    return;
  }

  class LoadMore extends HTMLElement {
    constructor() {
      super();
      this.facetsShowing = document.querySelectorAll('[data-facets-showing]');
    }

    connectedCallback() {
      this.facetsShowing.forEach((count) => {
        count.textContent = this.dataset.resultCount;
      });
      this.addEventListener('click', this.load.bind(this));
    }

    load() {
      if (!this.dataset.next) {
        return;
      }

      fetch(this.dataset.next)
        .then((response) => response.text())
        .then((text) => {
          const collection = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-collection]');

          collection
            .querySelectorAll('[data-card-product]')
            .forEach((cardProduct) => {
              document.getElementById('product-grid').appendChild(cardProduct);

              this.facetsShowing.forEach((count) => {
                count.textContent = Number(count.textContent) + 1;
              });
            });

          this.dataset.next =
            collection.querySelector('load-more').dataset.next;

          if (!this.dataset.next) {
            this.classList.add('hidden');
          }
        });
    }
  }

  customElements.define('load-more', LoadMore);
})();
